'use strict';

/**
 *
 * @name: searchButton
 *
 */

import DirectiveTemplate from './nn-search-button.directive.html';
import './nn-search-button.directive.scss';

function SearchButtonDirective($rootScope) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function(scope) {

      scope.item = scope.content();
      void 0;
      scope.item.title = scope.item.title || 'VIEW_FULL_ARCHIVE';
      scope.loaded = true;

      scope.runTheJewels = function() {

        if (!scope.item.jsonData.sources[0].categoryId) {

          $rootScope.location.search('search');
        } else {

          $rootScope.location.search('search').search('CategoryId', scope.item.jsonData.sources[0].categoryId);
        }
      };
    }
  };
}

export default SearchButtonDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-search-button/nn-search-button.directive.js